import React from 'react';
import PropTypes from 'prop-types';

import ProjectMeta from 'components/atoms/textMeta';

import './style.css';

const MetaGrid = ({ items }) => {
    return (
        <div className="MetaGrid">
            {items.map((item, i) => (
                <div className="MetaGrid__item" key={i}>
                    <ProjectMeta {...item} />
                </div>
            ))}
        </div>
    );
};

MetaGrid.propTypes = {
    items: PropTypes.array
};

MetaGrid.defaultProps = {
    items: [
        {
            title: 'Meta Title',
            value: 'Meta Value'
        },
        {
            title: 'Meta Title',
            value: 'Meta Value'
        },
        {
            title: 'Meta Title',
            value: 'Meta Value'
        },
        {
            title: 'Meta Title',
            value: 'Meta Value'
        }
    ]
};

export default MetaGrid;



// WEBPACK FOOTER //
// ./src/components/molecules/metaGrid/index.js